var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33853 11.5563C8.72962 11.5563 9.11687 11.4787 9.47818 11.3279C9.8395 11.1771 10.1678 10.9561 10.4443 10.6776C10.7209 10.399 10.9402 10.0683 11.0899 9.7043C11.2395 9.34033 11.3166 8.95022 11.3166 8.55625C11.3166 7.7606 11.0028 6.99754 10.4443 6.43493C9.88584 5.87232 9.12836 5.55625 8.33853 5.55625C7.54871 5.55625 6.79123 5.87232 6.23274 6.43493C5.67424 6.99754 5.36048 7.7606 5.36048 8.55625C5.36048 8.95022 5.43751 9.34033 5.58717 9.7043C5.73684 10.0683 5.9562 10.399 6.23274 10.6776C6.79123 11.2402 7.54871 11.5563 8.33853 11.5563ZM8.33853 0.15625C12.9366 0.15625 16.6771 3.91225 16.6771 8.55625C16.6771 14.8563 8.33853 24.1562 8.33853 24.1562C8.33853 24.1562 0 14.8563 0 8.55625C0 6.32843 0.878522 4.19186 2.4423 2.61655C4.00608 1.04125 6.12702 0.15625 8.33853 0.15625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6d0c3fef3887f699ca8e7997a17d5f44.svg";
export { ForwardRef as ReactComponent };